const fillFormSchema = (schema, counties) => {
  const updatedSchema = { ...schema };
  updatedSchema.properties.county.options = counties;
  updatedSchema.properties.county.enum =
    counties.length > 0 ? counties.map(([v, _]) => v) : undefined;
  if (counties.length > 0) {
    updatedSchema.properties.county.isRequired = true;
    updatedSchema.properties.county.minLength = 1;
    if (!updatedSchema.required.includes('county')) {
      updatedSchema.required = [...updatedSchema.required, 'county'];
    }
  } else {
    updatedSchema.properties.county.isRequired = false;
    delete updatedSchema.properties.county.minLength;
    updatedSchema.required = updatedSchema.required.filter(field => field !== 'county');
  }

  return updatedSchema;
};

export default fillFormSchema;
